import store from "@/store"




export const authMiddleware = (to, from, next) => {

        if (to.matched.some(record => record.meta.requiredAuth)) {
                if (!store.state.auth.user.isLogin) {
                        store.dispatch("auth/user/checkToken", null, { root: true }).then(() => {
                                next()
                        }).catch(() => {

                                next({ name: 'AuthLogin' });
                        })

                }
                else {
                        next();
                }
        } else {
                next();
        }
};



export const guardMiddleware = (to, from, next) => {

        if (to.meta.permissions) {
                const permissions = to.meta.permissions
                const userPermissions = store.state.auth.user.item?.permissions ?? [];


                const userPermissionNames = userPermissions?.map(({ name }) => name)

                var isPermis = false;

                permissions.forEach((permis) => {
                        if (userPermissionNames.includes(permis)) {
                                isPermis = true;
                        }
                });
                if (isPermis) {
                        next();
                } else {
                        next({ name: "Dashboard" })
                }



        } else {
                next();
        }
};

export const titleMiddleware = (to,from,next)=>{
        const title = document.querySelector('title')
        if(to.meta.title && title){
                title.innerHTML = to.meta.title
        }
        next()
}




